<template>
  <section class="c-section c-section--about">

    <b-skeleton-wrapper :loading="contextLoading">
      <template #loading>
          <b-card>
            <div class="container-fluid">
              <div style="height:400px">
                <div class="w-100 d-flex justify-content-center">
                  <b-skeleton-img no-aspect width="100%" height="300px"></b-skeleton-img>
                </div>
              </div>
            </div>
            <div class="container">
              <b-row>
                <b-col cols="6">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
                <b-col cols="3">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
                <b-col cols="3">
                  <b-skeleton-img no-aspect height="500px"></b-skeleton-img>
                </b-col>
              </b-row>

              <b-row >
                <b-col cols="3">
                  <b-skeleton-img no-aspect height="500px"></b-skeleton-img>
                </b-col>
                <b-col cols="3">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
                <b-col cols="6">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </template>
      <div
        v-if="context.banner"
        class="c-banner-top"
        :style="{ 'background-image': `url(${context.banner.fondo})` }"
      >
        <div class="c-banner-top__background"></div>
        <div class="c-banner-top__title">
          <h2 data-aos="fade-up" class="fs-72 white w-regular f3 text-center mb-0">
            {{context.banner.titulo}}
          </h2>
        </div>
      </div>
      <div
        v-if="context.informacion"
        class="c-history py-5"
        :style="{ 'background-image': `url(${require('@/assets/images/fondo-craft.png')})` }"
      >
      <div class="container">
        <div class="py-5">
          <div
            class="
              row gy-5 flex-column-reverse flex-lg-row justify-content-between align-items-center"
            >
            <div class="col-12 col-lg-6">
              <div data-aos="fade-right" class="c-history__images">
                <figure class="c-history__image-top">
                  <img :src="context.informacion.imagen_1" alt="" class="w-100 h-100 of--cover">
                </figure>
                <figure class="c-history__image-bottom">
                  <img :src="context.informacion.imagen_2" alt="" class="w-100 h-100 of--cover">
                </figure>
              </div>
            </div>
            <div class="col-12 col-lg-5">
              <div data-aos="fade-left">
                <h2 class="f2 fs-16 pri-color sec-color w-bold">
                  <span>
                    <Icon icon="vaadin:line-h"/>
                  </span>
                  <span class="me-3">
                    <Icon icon="vaadin:line-h"/>
                  </span>
                  {{context.informacion.subtitulo}}
                </h2>
                <h2 class="fs-25 w-sbold gray-black mb-4 text-uppercase">
                  {{context.informacion.titulo}}
                </h2>
                <p class="fs-16 black w-light mb-4 line-height">
                  {{context.informacion.resumen}}
                </p>
                <div class="d-md-flex mb-4">
                  <a :href="`mailto:${general.data.information.email}`"
                    class="c-history__link mb-4 mb-md-0 me-md-4">
                    <span class="c-history__icon me-3">
                      <Icon icon="carbon:email"/>
                    </span>
                    {{general.data.information.email}}
                  </a>
                  <a :href="`https://api.whatsapp.com/send?phone=${general.data.information.phone}&text=Hola%20Quisiera%20saber%20más%20...`"
                    target="_blank"
                    class="c-history__link">
                    <span class="c-history__icon me-3">
                      <Icon icon="ph:whatsapp-logo-light"/>
                    </span>
                    {{general.data.information.phone}}
                  </a>
                </div>
                <div class="d-flex">
                  <a href="/producto" class="c-button c-button--secondary">
                  VER PRODUCTO
                  <span class="d-flex fs-18 ms-2">
                    <Icon icon="teenyicons:arrow-right-solid"/>
                  </span>
                </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div
        v-if="context.preguntas"
        class="c-know py-5">
        <div class="py-5">
          <div class="container">
            <div class="c-know__contain">
              <div class="row justify-content-center">
                <div class="col-12 col-lg-10">
                  <div class="row gy-5 align-items-center">
                    <div class="col-12">
                      <h2 data-aos="fade-up" class="f2 fs-16 w-bold pri-color text-center">
                        {{context.preguntas.subtitulo}}
                      </h2>
                      <h2 data-aos="fade-up"
                      class="gray-dark fs-25 w-sbold text-center text-uppercase">
                        {{context.preguntas.titulo}}
                      </h2>
                      <p data-aos="fade-up" class="gray-dark fs-16 w-light text-center mb-2">
                        {{context.preguntas.resumen}}
                      </p>
                    </div>
                    <div class="col-12 col-lg-6">
                      <figure data-aos="fade-right" class="c-know__image">
                        <img :src="context.preguntas.imagen" alt="" class="w-100 h-100 of--cover">
                      </figure>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div
                        v-for="(item, i) of context.preguntas.lista_de_preguntas"
                        :key="i"
                        data-aos="fade-left"
                        :data-aos-delay="100 * (i + 1)"
                        class="mb-2"
                        >
                        <button v-b-toggle="'pregunta-' + i"
                          variant="primary" class="c-know__toggle">
                          <p class="mb-0 text-start">
                            {{item.pregunta}}
                          </p>
                          <span class="c-know__mas ms-4">
                            <Icon icon="fluent:add-20-filled"/>
                          </span>
                          <span class="c-know__line ms-4">
                            <Icon icon="pepicons-pencil:line-x"/>
                          </span>
                        </button>
                        <b-collapse :id="'pregunta-' + i" class="mt-2">
                          <b-card>
                            <p class="card-text">
                              {{item.respuesta}}
                            </p>
                          </b-card>
                        </b-collapse>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <figure  class="c-know__background">
          <img src="@/assets/images/fondo-know.png" alt="" class="w-100 h-100 of--cover">
        </figure>
      </div>
      <div
        v-if="context.reviews"
        class="c-testimony py-5"
        :style="{ 'background-image': `url(${context.reviews.fondo})` }"
      >
        <div class="c-testimony__contain py-2">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-12 col-md-8 col-lg-5">
                <div class="mb-2">
                  <h2 data-aos="fade-up" class="f2 fs-16 white w-bold w-100 text-center">
                    <span>
                      <Icon icon="vaadin:line-h"/>
                    </span>
                    <span class="me-3">
                      <Icon icon="vaadin:line-h"/>
                    </span>
                    {{context.reviews.subtitulo}}
                    <span class="ms-3">
                      <Icon icon="vaadin:line-h"/>
                    </span>
                    <span>
                      <Icon icon="vaadin:line-h"/>
                    </span>
                  </h2>
                  <h2 data-aos="fade-up"
                    class="white fs-25 w-sbold text-center mb-4 text-uppercase">
                    {{context.reviews.titulo}}
                  </h2>
                </div>
              </div>
            </div>
            <div data-aos="fade-up" class="position-relative">
              <div id="slider-testimony" class="c-slider-testimony swiper">
                <div class="swiper-wrapper position-relative">
                  <div class="swiper-slide"
                    v-for="(review,i) of context.reviews.lista_de_reviews"
                    :key="`review-${i}`"
                    data-aos="fade-up"
                    :data-aos-delay="100 * (i + 1)"
                  >
                    <div class="row justify-content-center">
                      <div class="col-12 col-md-10 col-lg-6">
                        <div class="c-stars mb-4">
                          <span
                            class="c-stars-star "
                            v-for="i in Array.from({ length: 5 }, (_, i) => i + 1)"
                            :key="`review-${i}`"
                            :class="{'active': i <= review.numero_de_estrellas}"
                          >
                              <Icon icon="material-symbols:star"/>
                          </span>
                        </div>
                        <h2 class="fs-16 text-center w-regular white f4 line-height mb-4">
                          {{review.comentario}}
                        </h2>
                        <div class="c-profile">
                          <figure class="c-profile__avatar mb-4">
                            <img
                              :src="review.imagen_de_usuario"
                              alt=""
                              class="w-100 h-100 of--cover"
                            >
                          </figure>
                          <div>
                            <h2 class="white fs-16 w-bold text-center mb-0">
                              {{review.nombre_de_usuario}}
                            </h2>
                            <h2 class="white fs-16 w-regular text-center">
                              {{review.rol}}
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button id="slider-testimony-prev" class="c-prev">
                <Icon icon="teenyicons:arrow-left-solid" class="w-100 h-100"/>
              </button>
              <button id="slider-testimony-next" class="c-next">
                <Icon icon="teenyicons:arrow-right-outline" class="w-100 h-100"/>
              </button>
            </div>
          </div>
        </div>
        <div class="c-testimony__background"></div>
      </div>
      <div
        v-if="context.bloque"
        class="c-banner-bot py-5"
      >
      <div class="py-2">
        <div class="container">
          <div
            class="c-banner-bot__image text-center text-lg-start px-3 py-5 py-lg-4 px-lg-0"
            :style="{ 'background-image': `url(${context.bloque.fondo})` }"
          >
            <div class="c-banner-bot__contain px-2 px-md-5">
              <div class="d-md-flex align-items-center mb-5 mb-lg-0">
                <div data-aos="fade-up"
                  class="mb-4 mb-md-0 me-md-4 d-flex justify-content-center d-md-block">
                  <figure class="c-banner-bot__logo">
                    <img :src="context.bloque.icono" alt="" class="w-100 h-100 of--cover">
                  </figure>
                </div>
                <div>
                  <h2 data-aos="fade-up" class="white fs-25 w-sbold f4">
                    {{context.bloque.titulo}}
                  </h2>
                  <h2 data-aos="fade-up" class="white f4 fs-16 w-regular">
                    {{context.bloque.resumen}}
                  </h2>
                </div>
              </div>
              <div>
                <a href="/contacto" class="c-button c-button--primary d-inline-flex">
                  CONTACTAR
                  <span class="d-flex fs-18 ms-2">
                    <Icon icon="teenyicons:arrow-right-solid"/>
                  </span>
                </a>
              </div>

            </div>
            <div class="c-banner-bot__backgraund"></div>
          </div>
        </div>
      </div>
      </div>
    </b-skeleton-wrapper>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import {
  Swiper,
  Navigation,
  Pagination,
  Autoplay,
} from 'swiper';

export default {
  data() {
    return {
      sliderTestimony: null,
      context: {},
      contextLoading: true,
    };
  },
  computed: {
    ...mapState(['general']),
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'nosotros' });
  },
  mounted() {
    this.initTestimonySlider();
  },
  methods: {
    initTestimonySlider() {
      window.setTimeout(() => {
        this.sliderTestimony = new Swiper('#slider-testimony', {
          modules: [Navigation, Pagination, Autoplay],

          autoHeight: true,
          speed: 1500,
          loop: true,
          spaceBetween: 0,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },

          pagination: {
            el: '#slider-testimony .swiper-pagination',
            type: 'bullets',
            clickable: true,
          },

          navigation: {
            prevEl: '#slider-testimony-prev',
            nextEl: '#slider-testimony-next',
          },
        });
      }, 1000);
    },
  },
};
</script>
